import DOMPurify from "dompurify";
import {marked} from "marked";
import "./MarkdownSpan.css";

export default function MarkdownSpan({ markdownText }) {
    return (
        <span className="markdown-componet" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(marked.parse(markdownText))}} />
    )
}
